module.exports = __webpack_public_path__ + "img/USA.7663a586.png";